import dayjs, { Dayjs } from 'dayjs';
import { WorkingHourDTO } from 'types';
import { isUndefined } from './commonUtils';
import { DateSelectArg } from 'fullcalendar';

const convertToDbTime = (date: Dayjs) => {
    return date.format('HH:mm') + ':00';
};

const convertToDbDate = (date: Dayjs) => {
    return date.format('YYYY-MM-DD');
};

const convertFromDbTime = (time: string) => {
    if (isUndefined(time)) return;
    const [hour, minute] = time.split(':').map(Number);

    return dayjs().hour(hour).minute(minute).second(0).millisecond(0);
};

const convertFromDbDate = (date: string) => {
    return dayjs(date);
};

/* GLOBAL FUNCTIONS */
export const convertDateFromForm = (fieldsValue: any) => {
    return {
        ...fieldsValue,
        date: convertToDbDate(fieldsValue.date),
    };
};

export const convertDatesFromForm = (fieldsValue: any) => {
    return {
        ...fieldsValue,
        date_from: fieldsValue.date_from && convertToDbDate(fieldsValue.date_from),
        date_to: fieldsValue.date_to && convertToDbDate(fieldsValue.date_to),
    };
};

export const convertValidFromForm = (fieldsValue: any) => {
    return {
        ...fieldsValue,
        valid_from: fieldsValue.valid_from && convertToDbDate(fieldsValue.valid_from),
    };
};

/* TERMS */
export const convertFromTermGenerator = (id: number, date: Dayjs, fieldsValue: any) => {
    return {
        id: id,
        work_date: convertToDbDate(date),
        time_from: convertToDbTime(fieldsValue.time_from),
        time_to: convertToDbTime(fieldsValue.time_to),
    };
};

/* WORKING HOUR */
export const convertToWhForm = (wh: WorkingHourDTO) => {
    return {
        ...wh,
        time_from: convertFromDbTime(wh.time_from),
        time_to: convertFromDbTime(wh.time_to),
    };
};

export const convertFromWhForm = (fieldsValue: any) => {
    return {
        ...fieldsValue,
        time_from: convertToDbTime(fieldsValue.time_from),
        time_to: convertToDbTime(fieldsValue.time_to),
    };
};

/** RESERVATIONS */
export const convertToReservationForm = (obj: DateSelectArg) => {
    return {
        work_date: convertFromDbDate(obj.endStr),
        time_from: convertFromDbDate(obj.startStr),
        time_to: convertFromDbDate(obj.endStr),
    };
};

export const convertFromReservationForm = (fieldsValue: any) => {
    return {
        ...fieldsValue,
        work_date: convertToDbDate(fieldsValue.work_date),
        time_from: convertToDbTime(fieldsValue.time_from),
        time_to: fieldsValue.time_to && convertToDbTime(fieldsValue.time_to),
    };
};

/** VALIDATION MESSAGES */
export const validateMessages = () => {
    return {
        required: 'Tohle pole je povinné.',
        types: {
            email: 'Prosím, zadejte platný email.',
            number: 'Prosím, zadejte platné telefonní číslo.',
        },
        number: {
            range: 'Telefonní číslo musí obsahovat 9 číslic.',
        },
    };
};
